import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-digital-signin',
  templateUrl: './digital-signin.component.html',
  styleUrls: ['./digital-signin.component.scss']
})
export class DigitalSigninComponent {
  @Input() isVisible: boolean = false;
  @Input() PrintFormatTypes: any[] = [];
  @Output() close = new EventEmitter<void>();

  selectedFormat: string = '';
  file1: File | null = null;
  file1Name: string = '';
  isDropdownOpen = false;
  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.file1 = file;
      this.file1Name = file.name;
    }
  }

  selectFormat(value: string, event: Event) {
    event.preventDefault(); // prevent anchor default behavior
    this.selectedFormat = value;
    this.isDropdownOpen = false
  }
  submit() {
    if (!this.selectedFormat) {
      alert('Please select a print format!');
      return;
    }
    const formData = new FormData();
    formData.append('pdfFile', this.file1);
    formData.append('formatType', this.selectedFormat);

    console.log('Submitting form data:', this.selectedFormat, this.file1);

    this.closeModal();
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  onBackdropClick(event: MouseEvent) {
  // Only close if click is on the backdrop, not inside the modal
  this.closeModal();
}

closeModal() {
  this.isDropdownOpen = false; // close dropdown if open
  this.close.emit();
}
}
